import React from 'react';
import { useNavigate } from "react-router-dom";
//import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
// import OutlinedInput from '@mui/material/OutlinedInput';
// import FormControl from '@mui/material/FormControl';
// import Radio from '@mui/material/Radio';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
// import InputAdornment from '@mui/material/InputAdornment';
// import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress';
// import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import AccountDetails from './AccountDetails';
// import AccountSaveEdit from './AccountSaveEdit';
// import AccountSaveNew from './AccountSaveNew';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
///import moment from 'moment';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	
	const urlParams = new URLSearchParams(window.location.search);
	const accountNumber = urlParams.get('accountNumber');

	const childRefDetails = React.useRef();
	// const childRefSaveNew = React.useRef();
	// const childRefSaveEdit = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");

	const [dataLoading, setDataLoading] = React.useState(true);

	// const [filter, setFilter] = React.useState(false);
	// const [keyword, setKeyword] = React.useState("");
	// const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	// const [selectedRow, setSelectedRow] = React.useState(0);
	const [dataObj, setDataObj] = React.useState({});
	// const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(accountNumber && userObj.registerId && userObj.loginId && userObj.fullName && userObj.token){
			getApiData(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);
		}else{
			///window.location.href='dashboard';
		}
	}, [accountNumber,userObj]);

	async function getApiData(registerId,uid,fullName,token){ 
		  let apiUrl=API_URL+'/crm-list-accounts?accountNumber='+accountNumber;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': registerId,
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
					if(response.data.list && response.data.list.length>0){
						setDataObj(response.data.list[0]);	
					}								 				
					setPrivileges(response.data.privileges);
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
					
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				  setSeverityAlert("error");
				  setShowAlert(true);
				  setAlertMessage(""+error);			
				  return false;
		  	})	
	}

	React.useEffect(() => {		
		if(dataObj){
			childRefDetails.current.handleClickOpen();
		}
	}, [dataObj]);

	// function saveData(opt){
	// 	if(opt===1){
	// 		setDataObj(null);
	// 		childRefSaveNew.current.handleClickOpen();
	// 	}else if(opt===2){
	// 		childRefSaveEdit.current.handleClickOpen();
	// 	}else if(opt===3){
	// 		if(dataObj){
	// 			childRefDetails.current.handleClickOpen();
	// 		}
	// 	}
	// }


	function hideAlert(){
		setShowAlert(false);
	}
	
	return (
		<div> 
				<MetaTags>
            		<title>Accounts</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Accounts" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>

					</div>

				</Box>
				
			<AccountDetails dataObj={dataObj} userObj={userObj} privileges={privileges} closebtn={false} ref={childRefDetails} />						

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
					
				<Authorization ref={childRefAuthorization} />
		</div>	
	);
  }